/* globals INITIAL_STATE */
import offersRootReducer from './products';
import linksRootReducer from './links';
import instapayRootReducer from './instapay';

const retry = () => {
  const {
    response_type: responseType,
  } = INITIAL_STATE;

  if (responseType == 'link') {
    return linksRootReducer;
  }
  else if (responseType == 'instapay') {
    return instapayRootReducer;
  }
  else {
    return offersRootReducer;
  }
};

export default retry();



// WEBPACK FOOTER //
// ./src/payments/reducers/retry.js